<div class="switch" [class.switch--disabled]="disabled" [class.switch--active]="active">
    <div class="switch__button" (click)="toggle()">
        <div class="switch__circle"></div>
        <div class="switch__groove"></div>
    </div>
    <div class="switch__label">{{ text }}</div>
</div>
